/*
 * Project: LegalPlace assistant
 * File: src/redux/reducers/account_settings.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

import {
  CREATE_FIREBASE_ID,
  UPDATE_MAIL_FROM_INPUT,
  LOAD_MAIL_FROM_FB,
  LOAD_FLAT_UI,
  LOAD_OPTIONS,
  SET_EXISTANT_IN_FIREBASE,
  EDITED_DOCUMENT,
  SHOW_CONTACT_US,
  SET_CARD_PAYMENT,
  SET_X3_PAYMENT,
  SET_PAYPAL_PAYMENT,
  SET_DIRECT_PAYMENT,
  SET_CREAT_ASSIST,
  SHOW_LOGIN_MODAL,
  SHOW_SINGUP_MODAL,
} from '../actions/account_settings';

export function account_settings(state = {
  fb_id: 'NONE',
  mail: '',
  exists: false,
  flatData: [],
  options: [],
  variables: [],
  multiples: [],
  currentSection: 0,
  edited_doc: false,
  show_contact: false,
  card: true,
  x3: false,
  paypal: false,
  direct: false,
  is_crea_assist_sub: false,
  show_login_modal: false,
  show_singup_modal: false,
}, action) {
  switch (action.type) {
    case UPDATE_MAIL_FROM_INPUT:
      return { ...state, mail: action.value };
    case LOAD_MAIL_FROM_FB:
      return { ...state, mail: action.val };
    case SET_EXISTANT_IN_FIREBASE:
      return { ...state, exists: action.val };
    case LOAD_FLAT_UI:
      return { ...state, flatData: action.val };
    case LOAD_OPTIONS:
      return { ...state, options: action.val };
    case EDITED_DOCUMENT:
      return { ...state, edited_doc: action.edited };
    case SHOW_CONTACT_US:
      return { ...state, show_contact: action.val };
    case SET_CARD_PAYMENT:
      return { ...state, card: action.val };
    case SET_X3_PAYMENT:
      return { ...state, x3: action.val };
    case SET_PAYPAL_PAYMENT:
      return { ...state, paypal: action.val };
    case SET_DIRECT_PAYMENT:
      return {...state, direct: action.val}
    case SET_CREAT_ASSIST:
      return { ...state, is_crea_assist_sub: action.val };
    case SHOW_LOGIN_MODAL:
      return { ...state, show_login_modal: action.val };
    case SHOW_SINGUP_MODAL:
      return { ...state, show_singup_modal: action.val };
    default:
      return state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/account_settings.js